import { UserRoleType } from '@Utils/enums/userRoleType';
const { EMPLOYEE, MANAGER, ADMIN, SUPER_ADMIN } = UserRoleType;

export const isEmployee = (user) => user.userRole?.roleType === EMPLOYEE;

export const isManager = (user) => user.userRole?.roleType === MANAGER;

export const isAdmin = (user) => user.userRole?.roleType === ADMIN;

export const isManagerOrAdmin = (user) => isManager(user) || isAdmin(user);

export const isSuperAdmin = (user) => user.userRole?.roleType === SUPER_ADMIN;

export const isAdminOrSuperAdmin = (user) => isAdmin(user) || isSuperAdmin(user);
